import React, { useEffect, useState } from "react";
import QRCode from "qrcode";

/**
 * QR gerado no browser — o secret TOTP não vai para API externa.
 */
type Props = {
  value: string;
  size?: number;
  alt: string;
};

const QrCodeImage = ({ value, size = 200, alt }: Props) => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, {
      width: size,
      margin: 2,
      errorCorrectionLevel: "M",
    })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (!src) {
    return (
      <div
        className="bg-light border rounded d-flex align-items-center justify-content-center"
        style={{ width: size, height: size }}
        aria-hidden
      />
    );
  }

  return <img src={src} width={size} height={size} alt={alt} className="rounded border" />;
};

export default QrCodeImage;
